import { useRef } from 'react';

import styled from 'styled-components';

import { Stack } from '@components/stack';
import { Text } from '@components/text/text';
import { theme } from '@styles/index';
import { pxToRem } from '@utils/converters';

import { TextArea, TextAreaProps } from './textarea';

type TextAreaDynamicProps = TextAreaProps & {
  maxHeight?: number;
  maxLength?: number;
  helpText?: string;
};

export const TextAreaDynamic = ({
  maxHeight = Infinity,
  helpText,
  children,
  style,
  ...rest
}: TextAreaDynamicProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  return (
    <Container>
      <StyledTextArea ref={textareaRef} style={style} {...rest}>
        <div className="hidden-text" style={style}>
          {textareaRef?.current?.value}
          <br />
          <br />
        </div>
        {children}
      </StyledTextArea>
      {helpText && <Text font="regular14" color="textSecondary" text={helpText} />}
    </Container>
  );
};

const Container = styled(Stack).attrs({
  space: 1,
})({
  position: 'relative',
  '.textarea-wrapper': {
    position: 'relative',
    width: '100%',
  },
  '> *': {
    whiteSpace: 'pre-wrap',
  },
  '.hidden-text': {
    opacity: 0,
    font: theme.font.regular16,
    padding: `${pxToRem(0)} ${pxToRem(12)}`,
    minHeight: pxToRem(72),
    border: `${pxToRem(1)} solid black`,
    wordBreak: 'break-word',
  },
});

const StyledTextArea = styled(TextArea)({
  width: '100%',
  resize: 'none',
  position: 'absolute',
  top: 0,
  left: 0,
  overflow: 'hidden',
  boxSizing: 'border-box',
  height: '100%',
  overflowY: 'auto',
  paddingTop: pxToRem(12),
  minHeight: pxToRem(72),
  '&::placeholder': {
    font: theme.font.regular16,
  },
});
